import { faChevronLeft, faChevronRight, faSearchPlus } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { ReactImageGalleryItem } from "react-image-gallery";

import { Props } from "@/mk2/apps/wiki/containers/ArticlePhoto/ArticlePhotoPage";
import { wikiArticlePhotoUrl } from "@/mk2/apps/wiki/urls";
import { ImageGalleryLoadable } from "@/mk2/components/ImageGalleryLoadable";
import { LoadingSwitch } from "@/mk2/containers/LoadingSwitch/LoadingSwitch";
import { url } from "@/mk2/helpers/urls";
import { PhotoEntity } from "@/mk2/schemas";
import { photoUrl } from "@/mk/photo/photoUrl";

import styles from "./ArticlePhoto.mscss";
import "./ArticlePhoto.scss";

export class ArticlePhoto extends React.Component<Props> {
    public render() {
        const { loadingState, article } = this.props;

        return (
            <div className={styles.ArticlePhoto}>
                <LoadingSwitch
                    loadingState={loadingState}
                    onLoad={this.load}
                    onRenderSuccess={this.renderSuccess}
                    hasData={Boolean(article)}
                />
            </div>
        );
    }

    private renderSuccess = () => {
        const { article, articlePhoto } = this.props;

        const currentIndex: number = article.photos.findIndex((p) => p.id === articlePhoto.id);

        const galleryPhotos: ReactImageGalleryItem[] = article.photos.map((p) => ({
            original: photoUrl(p, "s738x738"),
            thumbnail: photoUrl(p, "s150x150"),
            fullSizeUrl: photoUrl(p, "s1600x1600"),
        }));

        return (
            <>
                <div className={styles.ArticlePhoto__gallery}>
                    <ImageGalleryLoadable
                        items={galleryPhotos}
                        showIndex
                        showThumbnails={false}
                        autoPlay={false}
                        showPlayButton={false}
                        showFullscreenButton={false}
                        slideDuration={500}
                        startIndex={currentIndex}
                        onSlide={this.onSlide}
                        renderLeftNav={this.renderLeftNav}
                        renderRightNav={this.renderRightNav}
                        renderCustomControls={this.renderCustomControls}
                    />
                </div>
            </>
        );
    };

    private renderLeftNav = (onClick, disabled) => {
        return (
            <div
                key="prev"
                className={styles.ArticlePhoto__prev}
                onClick={disabled ? undefined : onClick}
            >
                <FontAwesomeIcon icon={faChevronLeft} className={styles.ArticlePhoto__prev__icon} />
            </div>
        );
    };

    private renderRightNav = (onClick, disabled) => {
        return (
            <div
                key="next"
                className={styles.ArticlePhoto__next}
                onClick={disabled ? undefined : onClick}
            >
                <FontAwesomeIcon
                    icon={faChevronRight}
                    className={styles.ArticlePhoto__next__icon}
                />
            </div>
        );
    };

    private renderCustomControls = () => {
        const { article, photoId } = this.props;
        const photo: PhotoEntity = article.photos.find((p) => p.id === photoId);
        const showMagnifier = photo?.versions?.includes("s1600x1600");
        if (!showMagnifier) {
            return null;
        }

        return (
            <div className={styles.ArticlePhoto__controls}>
                {showMagnifier && (
                    <a
                        data-google-interstitial="false"
                        key="magnifier"
                        href={photoUrl(photo, "s1600x1600")}
                        target="_blank"
                        className={styles.ArticlePhoto__controls__control}
                        rel="noopener"
                    >
                        <FontAwesomeIcon icon={faSearchPlus} />
                    </a>
                )}
            </div>
        );
    };

    private onSlide = (currentIndex: number) => {
        const { article, history, routeParams } = this.props;
        const photo = article.photos[currentIndex];
        history.replace({
            pathname: url(wikiArticlePhotoUrl, {
                categorySlug: routeParams.categorySlug,
                articleSlug: routeParams.articleSlug,
                photoId: photo.id,
            }),
        });
    };

    private load = () => {
        const {
            routeParams: { categorySlug, articleSlug },
            photoId,
            onLoad,
        } = this.props;
        onLoad(articleSlug, categorySlug, photoId);
    };
}
